const utils = require('../../../lib/utils')

module.exports = {
	config: {
		isContainerComponent: true,
		focusAble: true,
		focusPriority: 1500
	},

	model: {
		title:      'BASE MESSAGE DECIDABLE',
		content:    'OVERWRITE THIS'
	},

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action(event){
				let positive = false
				switch(utils.keyboard.getKeyCode(event)){
					case 'enter':
						positive = true
					case 'esc':
						let $useButton
						if(positive){
							if(($useButton = event.data.component.$.find('section.footer button.positive:visible')).length == 1){
								event.stopImmediatePropagation()
								$useButton.click()
								return false
							}
						}
						else {
							if(
								($useButton = event.data.component.$.find('section.footer button.negative:visible')).length == 1
								||
								($useButton = event.data.component.$.find('> .background')).length == 1
							){
								event.stopImmediatePropagation()
								$useButton.click()
							}
						}
						break
				}
			}
		},


		decision: {
			type: 'click',
			selector: '.background, section.header button.close, section.footer button',
			action(event) {
				event.preventDefault()
				event.stopImmediatePropagation()

				event.data.component.decide({
					type: 		event.currentTarget.dataset.fieldType,
					context: 	event.currentTarget.dataset.buttonContext,
					mode: 		event.currentTarget.dataset.buttonMode
				})
			}
		}
	},

	hooks: {
		include($element, options){
			$element.find('section.footer').append(
				this.include(
					'../../form/elements/buttons',
					{
						formMapping: {
							buttons: (this.model.decisionScope || {}).buttons || this.model.buttons
						}
					}
				)
			)
		},

		attach($element, options){
			$element.addClass('active').removeClass('loading')
		},

		// fallback trigger
		async onDecision($element, options){
			await this.decide({
				type: options.decisionType
			})
		}
	}
}
